import * as v from "valibot";

export const AppConfig = v.object({
  environment: v.string(),
});

export const appConfig = v.parse(AppConfig, {
  environment: process.env["GADGET_ENV"],
});
